import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label"
}, "Email Address", -1)
const _hoisted_8 = ["readonly"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Invite Admin User ")

import { onMounted, Ref, ref, watch } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { ValidationError, validationMessage } from "@/model/validation-error";
import ModalView from "@/components/ModalView.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
}

let name: Ref<string | null> = ref(null);
let nameError: Ref<string | null> = ref(null);
let emailAddress: Ref<string | null> = ref(null);
let emailAddressError: Ref<string | null> = ref(null);
let loading: Ref<boolean> = ref(false);





async function inviteAdminUser() {
  loading.value = true;
  const functions = getFunctions();
  const inviteAdminUser = httpsCallable(functions, "inviteAdminUser");
  await inviteAdminUser({
    emailAddress: emailAddress.value,
    name: name.value,
    acceptUrl: window.location.host,
  })
    .then(() => {
      emit("hide-modal");
    })
    .catch((error) => {
      if (error.code == "functions/already-exists") {
        emailAddressError.value = "User already invited";
      } else if (error.details) {
        let validationErrors = error.details as ValidationError[];
        for (let validationError of validationErrors) {
          switch (validationError.field) {
            case "emailAddress": {
              emailAddressError.value = validationMessage(
                validationError.reason
              );
              break;
            }
            case "name": {
              nameError.value = validationMessage(validationError.reason);
              break;
            }
          }
        }
      }
    });

  loading.value = false;
}

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      name.value = null;
      emailAddress.value = null;
    }
  }
);

watch(
  () => name.value,
  () => {
    nameError.value = null;
  }
);

watch(
  () => emailAddress.value,
  () => {
    emailAddressError.value = null;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[2] || (_cache[2] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(nameError) }]),
            id: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : name = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_4), [
            [_vModelText, _unref(name)]
          ]),
          (_unref(nameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(nameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(emailAddressError) }]),
            id: "emailAddress",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(emailAddress) ? (emailAddress).value = $event : emailAddress = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_8), [
            [_vModelText, _unref(emailAddress)]
          ]),
          (_unref(emailAddressError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(emailAddressError)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) }]),
        onClick: inviteAdminUser
      }, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
          : _createCommentVNode("", true),
        _hoisted_11
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})